export default "__VITE_ASSET__sVS41X38__"